'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/syntax.js
// module id = msXq
// module chunks = 0